
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const DeduplicateConfig = ({ data, onChange, inputColumns }: any) => {

    const mode: string = data.mode || 'all'; // 'all' | 'subset'

    const toggleColumn = (colName: string) => {
        const current = data.columns || [];
        if (current.includes(colName)) {
            onChange('columns', current.filter((c: string) => c !== colName));
        } else {
            onChange('columns', [...current, colName]);
        }
    };

    return (
        <div className="space-y-4">

            {/* Mode toggle */}
            <div className="space-y-2">
                <label className="text-xs font-semibold text-gray-700 uppercase tracking-wider">Deduplication Mode</label>
                <div className="flex bg-gray-100 p-1 rounded-lg">
                    <button
                        className={`flex-1 text-xs py-1.5 rounded-md font-medium transition-all ${mode === 'all' ? 'bg-white shadow text-teal-700' : 'text-gray-500 hover:text-gray-700'}`}
                        onClick={() => onChange('mode', 'all')}
                    >
                        All Columns
                    </button>
                    <button
                        className={`flex-1 text-xs py-1.5 rounded-md font-medium transition-all ${mode === 'subset' ? 'bg-white shadow text-teal-700' : 'text-gray-500 hover:text-gray-700'}`}
                        onClick={() => onChange('mode', 'subset')}
                    >
                        Specific Keys
                    </button>
                </div>
            </div>

            {/* Column checklist – only shown in Specific Keys mode */}
            {mode === 'subset' && (
                <div className="space-y-2">
                    <Label>Deduplication Columns</Label>
                    <div className="text-xs text-gray-500 mb-2">Check columns to identify duplicates. If none selected, all columns are used (distinct rows).</div>
                    <div className="max-h-60 overflow-y-auto border rounded p-2 bg-gray-50 space-y-1">
                        {inputColumns.map((col: any) => (
                            <div key={col.name} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    className="rounded border-gray-300 text-violet-600 focus:ring-violet-500 h-4 w-4"
                                    checked={(data.columns || []).includes(col.name)}
                                    onChange={() => toggleColumn(col.name)}
                                />
                                <span className="text-sm">{col.name}</span>
                            </div>
                        ))}
                        {inputColumns.length === 0 && <div className="text-xs text-gray-400 italic">No columns available.</div>}
                    </div>
                </div>
            )}

            {/* Keep Which Row */}
            <div className="space-y-2">
                <Label>Keep Which Row?</Label>
                <Select value={data.keep || 'first'} onValueChange={(v) => onChange('keep', v)}>
                    <SelectTrigger>
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="first">First Occurrence</SelectItem>
                        <SelectItem value="last">Last Occurrence</SelectItem>
                    </SelectContent>
                </Select>
                <div className="text-xs text-gray-400">Determines which row to retain when duplicates are found.</div>
            </div>
        </div>
    );
};
